module.exports = __webpack_public_path__ + "img/9-13.1fa49536.jpg";